import React, { Component, createRef } from 'react'
import { Table, Tooltip, Icon } from 'antd'
import LangContext from 'modules/shared/context/langContext'
import VehiclePhoneCall from 'modules/voice/components/VehiclePhoneCall'

const columnStyle = { fontSize: '12px', fontWeight: '400' }
const phoneIconStyle = { transform: 'scaleX(-1)' }
const tagRed = {
  backgroundColor: '#F5F50E',
  color: 'black',
  fontSize: '11px',
  lineHeight: '15px',
  fontWeight: '600',
}

// หัวตารางติดบนตอนเลื่อนรายการลง · หัวตาราง antd แบบ small พื้นโปร่งใส จึงใส่สีเดียวกับหัวตารางทั้งแอปเอง
const headerStyle = {
  position: 'sticky',
  top: 0,
  zIndex: 2,
  backgroundColor: '#1890ff',
}
const stickyHeader = () => ({ style: headerStyle })

class ListVehicle extends Component {
  state = {
    visible: false,
  }

  tableWrapper = createRef()

  componentDidMount() {
    this.props.loadListVehicleHoneytoast(
      {
        ...this.props.filter,
        selectedDivision: this.props.selectedDivision,
        selectedDepartment: this.props.selectedDepartment,
        selectedSection: this.props.selectedSection,
        selectedPlant: this.props.selectedPlant,
        plateno_select: this.props.vehicle_select,
      },
      true,
      res => {
        const search = window.location.search
        const params = new URLSearchParams(search)
        const vehicle_id = parseInt(params.get('vehicle_id'))
        if (!!vehicle_id) {
          const vehicle = res.find(item => item.id === vehicle_id)
          this.props.loadVehicleSelect(vehicle.id, vehicle.plate_no)
          this.scrollToRow(vehicle.row_number)
        }
      },
    )
    this.loadDataInterval = setInterval(async () => {
      this.props.loadListVehicleHoneytoast(
        {
          ...this.props.filter,
          selectedDivision: this.props.selectedDivision,
          selectedDepartment: this.props.selectedDepartment,
          selectedSection: this.props.selectedSection,
          selectedPlant: this.props.selectedPlant,
          plateno_select: this.props.vehicle_select,
        },
        true,
      )
    }, 1000 * 60 * 1)
  }

  componentWillUnmount() {
    clearInterval(this.loadDataInterval)
  }

  scrollToRow = index => {
    // Container that scrolls
    const body = document.querySelector('.ant-table-body')
    if (!body) return

    // Select table rows
    const rows = body.querySelectorAll('.ant-table-tbody > .ant-table-row')
    if (!rows.length) {
      console.warn('Rows not found yet, retrying...')
      setTimeout(() => this.scrollToRow(index), 50)
      return
    }

    if (!rows[index]) {
      console.warn('Row index out of range')
      return
    }

    rows[index].scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    })
  }

  render() {
    const { vehicle_select, allimei, vehicleListHoneytoast } = this.props

    let newArrTable = []
    if (allimei != null) {
      vehicleListHoneytoast.map(item => {
        if (allimei.includes(item.hardware_id)) {
          newArrTable.push({ ...item, status: 1 })
        } else {
          newArrTable.push({ ...item, status: 0 })
        }
      })
    }

    const columns = [
      {
        title: <div className="regular-bold-14">#</div>,
        dataIndex: 'row_number',
        width: '10%',
        className: 'column-text-center',
        onHeaderCell: stickyHeader,
        onCell: record => ({
          onClick: () =>
            this.props.loadVehicleSelect(record.id, record.plate_no),
        }),
        render(text, record) {
          return {
            props: {
              style:
                vehicle_select.indexOf(record.id) != -1 ? tagRed : columnStyle,
            },
            children: <div style={{ fontSize: '10px' }}>{text}</div>,
          }
        },
      },
      {
        title: (
          <div className="regular-bold-14">
            <LangContext.Consumer>
              {i18n => i18n.p.plateNo}
            </LangContext.Consumer>
          </div>
        ),
        dataIndex: 'plate_no',
        width: '42%',
        key: 'plate_no',
        sorter: false,
        onHeaderCell: stickyHeader,
        onCell: record => ({
          onClick: () => {
            this.props.loadVehicleSelect(record.id, record.plate_no)
          },
        }),
        render(text, record) {
          const phoneText = record.phone_number
            ? record.phone_number.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3')
            : record.phone_number
          return {
            props: {
              style:
                vehicle_select.indexOf(record.id) != -1 ? tagRed : columnStyle,
            },
            children: (
              <div>
                <div style={{ fontSize: '11px' }}>{text}</div>
                <div style={{ fontSize: '14px', fontWeight: 600 }}>
                  <VehiclePhoneCall
                    vehicleId={record.id}
                    plateNo={record.plate_no}
                    phoneText={phoneText}
                    iconStyle={phoneIconStyle}
                  />{' '}
                  :{phoneText}
                </div>
              </div>
            ),
          }
        },
      },
      {
        title: (
          <div className="regular-bold-14">
            <LangContext.Consumer>
              {i18n => i18n.s.statusVehicleVideo}
            </LangContext.Consumer>
          </div>
        ),
        className: 'column-text-center',
        dataIndex: 'status',
        width: '18%',
        onHeaderCell: stickyHeader,
        onCell: record => ({
          onClick: () => {
            this.props.loadVehicleSelect(record.id, record.plate_no)
          },
        }),
        render(_, record) {
          let color = ''
          let tooltipMessage = ''
          if (record.vehicle_status == 'running') {
            color = '#00BF06'
            tooltipMessage = (
              <LangContext.Consumer>
                {i18n => i18n.r.running}
              </LangContext.Consumer>
            )
          } else if (record.vehicle_status == 'stop-with-engine-on') {
            color = '#ffd619'
            tooltipMessage = (
              <LangContext.Consumer>
                {i18n => i18n.s.stopWithEngineOn}
              </LangContext.Consumer>
            )
          } else if (record.vehicle_status == 'stop-with-engine-off') {
            color = '#c91c1c'
            tooltipMessage = (
              <LangContext.Consumer>
                {i18n => i18n.e.engineOff}
              </LangContext.Consumer>
            )
          } else if (record.vehicle_status == 'connection-error') {
            color = '#848484'
            tooltipMessage = (
              <LangContext.Consumer>
                {i18n => i18n.l.lostConnectio}
              </LangContext.Consumer>
            )
          } else {
            color = 'blue'
            tooltipMessage = (
              <LangContext.Consumer>
                {i18n => i18n.l.lostConnectio}
              </LangContext.Consumer>
            )
          }

          return {
            props: {
              style:
                vehicle_select.indexOf(record.id) != -1 ? tagRed : columnStyle,
            },
            children: (
              <Tooltip title={tooltipMessage} placement="left">
                <Icon
                  type="car"
                  theme="twoTone"
                  twoToneColor={color}
                  style={{ fontSize: '16px' }}
                />
              </Tooltip>
            ),
          }
        },
      },
      {
        title: (
          <div className="regular-bold-14">
            <LangContext.Consumer>
              {i18n => i18n.vehicleContract.gpsVendor}
            </LangContext.Consumer>
          </div>
        ),
        className: 'column-text-center',
        dataIndex: 'vendor_name',
        width: '30%',
        onHeaderCell: stickyHeader,
        onCell: record => ({
          onClick: () => {
            this.props.loadVehicleSelect(record.id, record.plate_no)
          },
        }),
        render(text, record) {
          return {
            props: {
              style:
                vehicle_select.indexOf(record.id) != -1 ? tagRed : columnStyle,
            },
            children: <div style={{ fontSize: '11px' }}>{text}</div>,
          }
        },
      },
    ]

    return (
      <div
        ref={ref => (this.tableWrapper = ref)}
        className="lsv1-vehicle-list"
        style={{ height: `${window.innerHeight - 140}px` }}
      >
        <Table
          bordered
          size="small"
          pagination={false}
          columns={columns}
          rowClassName={record =>
            record.drum_direction === 1 ? 'table-cement' : ''
          }
          rowKey={record => record.id}
          dataSource={vehicleListHoneytoast}
          loading={this.props.videoLoading}
        />
      </div>
    )
  }
}

export default ListVehicle
